
import React, { useEffect, useState, useRef } from 'react';
import ru from 'date-fns/locale/ru';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { handleRequest } from '../Helpers/Helpers';
import { apiFetch, readApiJson } from '../../api/http';

import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';

import './Childdata.css';

import Slider from './Slider/Slider';
import PopUpRate from './PopUpRate/PopUpRate';
import TextField from '@mui/material/TextField';



function Childdata(props) {
	const { handlers } = props;
	const [clientData, setClientData] = useState([]);
	const [childrenData, setChildrenData] = useState([]);
	const [date, setDate] = useState('');
	const [birthDate, setBirthDate] = useState(null);
	const [popUpState, setPopUpState] = useState(false);
	const [criterionPopUpData, setCriterionPopUpData] = useState({});

	const [clientQuery, setClientQuery] = useState('');
	const [childQuery, setChildQuery] = useState('');
	const [selectedClient, setSelectedClient] = useState(null);
	const [clientOpen, setClientOpen] = useState(false);
	const [childOpen, setChildOpen] = useState(false);
	const [childrenLoading, setChildrenLoading] = useState(false);
	const [childrenError, setChildrenError] = useState('');
	const [clientHelper, setClientHelper] = useState('');
	const [childHelper, setChildHelper] = useState('Сначала выберите клиента');
	const [clientTouched, setClientTouched] = useState(false);
	const [childTouched, setChildTouched] = useState(false);
	// Browsers (esp. Yandex) ignore autocomplete=off; readonly-until-focus blocks autofill.
	const [clientReadOnly, setClientReadOnly] = useState(true);
	const [childReadOnly, setChildReadOnly] = useState(true);

	const [dataAbout, setDataAbout] = useState({
		valueName: '',
		dataChildId: '',
		versionWheel: null,
		dataClientId: '',
	});

	const clientPickerRef = useRef(null);
	const childPickerRef = useRef(null);

	const notifySelection = ({ clientId = '', childId = '', childName = '' } = {}) => {
		if (typeof handlers.setSelectedClientId === 'function') {
			handlers.setSelectedClientId(clientId ? String(clientId) : '');
		}
		if (typeof handlers.setSelectedChildId === 'function') {
			handlers.setSelectedChildId(childId ? String(childId) : '');
		}
		if (typeof handlers.setSelectedChildName === 'function') {
			handlers.setSelectedChildName(childName || '');
		}
	};

	const resetChildSelection = () => {
		setChildQuery('');
		setChildrenData([]);
		setChildrenError('');
		setChildHelper(selectedClient ? '' : 'Сначала выберите клиента');
		setDataAbout((prev) => ({
			...prev,
			valueName: '',
			dataChildId: '',
			versionWheel: null,
		}));
		handlers.setName('');
		handlers.setChildIsPicked(false);
		notifySelection({
			clientId: selectedClient?.client_id || '',
			childId: '',
			childName: '',
		});
		setDate('');
	};

	const filteredClients = (Array.isArray(clientData) ? clientData : []).filter((item) => {
		const name = String(item.client_name || '').toLowerCase();
		return name.includes(clientQuery.trim().toLowerCase());
	});

	const filteredChildren = (Array.isArray(childrenData) ? childrenData : []).filter((item) => {
		const name = String(item.name || '').toLowerCase();
		return name.includes(childQuery.trim().toLowerCase());
	});

	const handleClientChange = (e) => {
		const value = e.target.value;
		setClientQuery(value);
		setClientHelper('');
		setClientOpen(true);
		if (selectedClient) {
			setSelectedClient(null);
			setDataAbout((prev) => ({ ...prev, dataClientId: '' }));
			resetChildSelection();
			notifySelection({ clientId: '', childId: '', childName: '' });
			setChildHelper('Сначала выберите клиента');
		}
	};

	const handleSelectClient = (client) => {
		setSelectedClient(client);
		setClientQuery(client.client_name || '');
		setClientOpen(false);
		setClientHelper('');
		setChildHelper('');
		setChildQuery('');
		setChildrenData([]);
		setChildrenError('');
		setDataAbout((prev) => ({
			...prev,
			dataClientId: String(client.client_id ?? ''),
			dataChildId: '',
			valueName: '',
			versionWheel: null,
		}));
		handlers.setName('');
		handlers.setChildIsPicked(false);
		notifySelection({
			clientId: client.client_id,
			childId: '',
			childName: '',
		});
		setDate('');
		setChildrenLoading(true);

		apiFetch(`/getChild?row_id=${client.row_id}`)
			.then((response) => readApiJson(response, { expectArray: true }))
			.then(({ ok, body, message }) => {
				if (!ok) {
					setChildrenError(message || 'Не удалось загрузить детей клиента');
					setChildrenData([]);
					return;
				}
				const list = body;
				setChildrenData(list);
				if (list.length === 0) {
					setChildrenError('Нет детей у этого клиента');
				} else if (list.length === 1) {
					handleSelectChild(list[0], client);
				} else {
					setChildOpen(true);
				}
			})
			.catch(() => {
				setChildrenError('Не удалось загрузить детей клиента');
				setChildrenData([]);
			})
			.finally(() => setChildrenLoading(false));
	};

	const handleSelectChild = (child, clientOverride = null) => {
		const client = clientOverride || selectedClient;
		const name = child.name || '';
		const clientId = String(client?.client_id ?? dataAbout.dataClientId ?? '');
		const childId = String(child.child_id ?? '');
		setChildQuery(name);
		setChildOpen(false);
		setChildHelper('');
		setDataAbout((prev) => ({
			...prev,
			valueName: name,
			dataChildId: childId,
			dataClientId: clientId,
		}));
		handlers.setName(name);
		handlers.setChildIsPicked(true);
		notifySelection({ clientId, childId, childName: name });

		const birthRaw = String(child.birth_date || '').trim();
		if (birthRaw) {
			const birth = new Date(birthRaw);
			if (!Number.isNaN(birth.getTime())) {
				const years = Math.floor((Date.now() - birth.getTime()) / (1000 * 60 * 60 * 24 * 365.25));
				setDate(years);
			}
		}
		getLastWheele(setDataAbout, child.child_id);
	};

	const handleChildChange = (e) => {
		const value = e.target.value;
		setChildQuery(value);
		setChildHelper('');
		setChildOpen(true);
		if (dataAbout.dataChildId) {
			setDataAbout((prev) => ({
				...prev,
				dataChildId: '',
				valueName: '',
				versionWheel: null,
			}));
			handlers.setName('');
			handlers.setChildIsPicked(false);
			notifySelection({
				clientId: dataAbout.dataClientId || selectedClient?.client_id || '',
				childId: '',
				childName: '',
			});
		}
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (clientPickerRef.current && !clientPickerRef.current.contains(event.target)) {
				setClientOpen(false);
			}
			if (childPickerRef.current && !childPickerRef.current.contains(event.target)) {
				setChildOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	useEffect(() => {
		apiFetch('/getClient')
			.then((response) => readApiJson(response, { expectArray: true }))
			.then(({ ok, body, message }) => {
				if (!ok) {
					setClientData([]);
					setClientHelper(message || 'Не удалось загрузить клиентов');
					return;
				}
				setClientData(body);
			})
			.catch(() => {
				setClientData([]);
				setClientHelper('Не удалось загрузить клиентов');
			});

		apiFetch('/getDateAge')
			.then((response) => readApiJson(response))
			.then(({ ok, body }) => {
				if (ok && body?.success && Array.isArray(body.data)) {
					setBirthDate(body.data);
				} else {
					setBirthDate(example);
				}
			})
			.catch(() => setBirthDate(example));
	}, []);

	return (
		<div className='child-data'>
			<h2>Данные ребёнка</h2>
			<div className='child-data-input-items'>
				<div className='child-data-input-item child-picker-stack'>
					{/* Decoy fields absorb browser/Yandex autofill heuristics */}
					<form
						className='child-picker-nofill'
						autoComplete="off"
						onSubmit={(e) => e.preventDefault()}
					>
						<input
							type="text"
							name="fake-username"
							autoComplete="username"
							tabIndex={-1}
							aria-hidden="true"
							className="child-picker-nofill-decoy"
						/>
						<input
							type="password"
							name="fake-password"
							autoComplete="current-password"
							tabIndex={-1}
							aria-hidden="true"
							className="child-picker-nofill-decoy"
						/>
					<div className='dropdown-children-container' ref={clientPickerRef}>
						<TextField
							onFocus={() => {
								setClientReadOnly(false);
								setClientOpen(true);
								setClientTouched(true);
							}}
							onChange={handleClientChange}
							onBlur={() => {
								if (clientTouched && !selectedClient) {
									setClientHelper('Выберите клиента из списка');
								}
							}}
							id="name-client"
							label="Клиент"
							variant="filled"
							fullWidth
							autoComplete="new-password"
							value={clientQuery}
							helperText={clientHelper}
							slotProps={{
								input: { disableUnderline: true },
								formHelperText: clientHelper ? { sx: { color: '#d32f2f' } } : undefined,
								htmlInput: {
									autoComplete: 'new-password',
									autoCorrect: 'off',
									autoCapitalize: 'off',
									spellCheck: 'false',
									name: 'wheel-client-search',
									readOnly: clientReadOnly,
									role: 'combobox',
									'aria-autocomplete': 'list',
								},
							}}
						/>
						{clientOpen && (
							<div className='dropdown-children-content dropdown-children-content--wide take-lesson-dropdown'>
								<p className='picker-dropdown-title'>Выберите клиента</p>
								{filteredClients.length === 0 ? (
									<p className='picker-empty'>Ничего не найдено</p>
								) : (
									filteredClients.map((element) => (
										<p
											key={element.row_id}
											className='picker-option'
											onMouseDown={(e) => e.preventDefault()}
											onClick={() => handleSelectClient(element)}
										>
											{element.client_name}
										</p>
									))
								)}
							</div>
						)}
					</div>

					<div className='dropdown-children-container' ref={childPickerRef}>
						<TextField
							onFocus={() => {
								setChildReadOnly(false);
								if (selectedClient) {
									setChildOpen(true);
									setChildTouched(true);
								}
							}}
							onChange={handleChildChange}
							onBlur={() => {
								if (selectedClient && childTouched && !dataAbout.dataChildId) {
									setChildHelper('Выберите ребёнка из списка');
								}
							}}
							id="name-child"
							label="Ребёнок"
							variant="filled"
							fullWidth
							autoComplete="new-password"
							disabled={!selectedClient}
							value={childQuery}
							helperText={
								!selectedClient
									? 'Сначала выберите клиента'
									: childrenLoading
										? 'Загрузка детей...'
										: childHelper
							}
							slotProps={{
								input: { disableUnderline: true },
								formHelperText:
									childHelper && selectedClient && !childrenLoading
										? { sx: { color: '#d32f2f' } }
										: undefined,
								htmlInput: {
									autoComplete: 'new-password',
									autoCorrect: 'off',
									autoCapitalize: 'off',
									spellCheck: 'false',
									name: 'wheel-child-search',
									readOnly: childReadOnly,
									role: 'combobox',
									'aria-autocomplete': 'list',
									'data-client-id': dataAbout.dataClientId,
									'data-child-id': dataAbout.dataChildId,
								},
							}}
						/>
						{childOpen && selectedClient && (
							<div className='dropdown-children-content take-lesson-dropdown'>
								<p className='picker-dropdown-title'>Выберите ребёнка</p>
								{childrenLoading ? (
									<p className='picker-empty'>Загрузка…</p>
								) : childrenError ? (
									<p className='picker-empty'>{childrenError}</p>
								) : filteredChildren.length === 0 ? (
									<p className='picker-empty'>Ничего не найдено</p>
								) : (
									filteredChildren.map((element) => (
										<p
											key={element.child_id}
											className='picker-option'
											onMouseDown={(e) => e.preventDefault()}
											onClick={() => handleSelectChild(element)}
										>
											{element.name}
										</p>
									))
								)}
							</div>
						)}
					</div>
					</form>
				</div>

				<div className='child-data-input-item'>
					<FormControl variant="filled" sx={{ width: "100%" }}>
						<InputLabel>Укажите возраст</InputLabel>
						{birthDate
							&& <DisplaySelectDateAge
								birthDate={birthDate}
								setVisibleSliderBlock={handlers.setVisibleSliderBlock}
								setCriterionRequestParam={handlers.setCriterionRequestParam}
								criterionRequestParam={handlers.criterionRequestParam}
								setSudentParametersValues={handlers.setSudentParametersValues}
								setListLessonItems={handlers.setListLessonItems}
								setCriterionError={handlers.setCriterionError}
							/>
						}
					</FormControl>
				</div>

				<div className='child-data-input-item'>

					<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
						<DatePicker
							slotProps={{
								textField: {
									name: 'assessment_date', variant: 'filled', fullWidth: true,
									InputProps: {
										disableUnderline: true,
									}
								}
							}}
							slots={{ openPickerIcon: CalendarTodayOutlinedIcon }}
							label="Дата урока"
							value={handlers.assessmentDate instanceof Date ? handlers.assessmentDate : new Date()}
							onChange={(next) => {
								if (typeof handlers.setAssessmentDate === 'function') {
									handlers.setAssessmentDate(next instanceof Date ? next : new Date());
								}
							}}
						/>
					</LocalizationProvider>
				</div>

				<div export-ignore='true' style={{ width: "100%" }}>
					<FormControl variant="filled" sx={{ width: "100%" }}>
						<InputLabel id="demo-simple-select-filled-label">Предыдущее колесо</InputLabel>
						{dataAbout.versionWheel && <DisplaySelectOption
							setDate={setDate}
							versionWheel={dataAbout.versionWheel}
							setDataLastWheel={handlers.setDataLastWheel}
							setVisibleSliderBlock={handlers.setVisibleSliderBlock}
							dropValues={handlers.dropValues}
							setCriterionRequestParam={handlers.setCriterionRequestParam} />}
					</FormControl>
				</div>

			</div>
			<div export-ignore='true' style={{ marginTop: '64px' }}>

				<div className='title-container'>
					<h2>Оцените текущее состояние ребёнка</h2>
				</div>
				{(handlers.visibleSliderBlock.direction && handlers.visibleSliderBlock.dateBirth) ? (
					<div>
						<div className='child-data-slider-items'>
							<DisplaySkillSlider
								data={handlers.skill}
								updateStudentParameter={handlers.updateData}
								studentValue={handlers.studentValue}
								setPopUpState={setPopUpState}
								setCriterionPopUpData={setCriterionPopUpData} />

						</div>
						<div className='drop-slider-value-container'>
							<button className='drop-slider-value-button drop-button' onClick={() => handlers.setDafaultStudendParameters()} export-ignore='true'>Сбросить параметры состояния</button>
						</div>
					</div>
				) : (
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<p className='child-data-slider'>Для продолжения выберите направление и возраст</p>
					</div>
				)}

			</div>
			{popUpState && <PopUpRate
				setPopUpState={setPopUpState}
				criterionRequestParam={handlers.criterionRequestParam}
				criterionPopUpData={criterionPopUpData} />}
		</div>
	)
}

export default Childdata;

function DisplaySkillSlider(props) {
	const {
		data,
		updateStudentParameter,
		studentValue,
		setPopUpState,
		setCriterionPopUpData,
	} = props;

	function isEmpty(obj) {
		return Object.keys(obj).length === 0;
	}

	const handleClick = (e) => {
		setCriterionPopUpData(
			{
				attributes: data[e.target.getAttribute('data-criteria')],
				criterionName: e.target.getAttribute('data-criteria')
			}
		);

		document.body.style.overflow = 'hidden';
		setPopUpState(true);
	}
	return (
		<>
			{Object.keys(data).map((category, index) => {
				return (
					<div className='child-data-slider-item' key={index}>
						<div className='slider-title'>
							<p>{category}</p>

							{
								!isEmpty(data[category]) &&
								<p className='criterion-rate'
									data-criteria={category}
									onClick={handleClick}
								>
									Критерии оценки
								</p>
							}
						</div>

						<Slider
							onChange={(v) => updateStudentParameter(category, v)}
							value={studentValue[category]}
							name={category}
						/>

						{/* Необязательно: отображение критериев */}
						{/* <ul>
				{descriptions.map((desc, idx) => (
				  <li key={idx}>{desc}</li>
				))}
			  </ul> */}
					</div>
				);
			})}
		</>
	);
}

function DisplaySelectOption(props) {
	const { versionWheel,
		setDataLastWheel,
		setDate,
		setVisibleSliderBlock,
		dropValues,
	} = props;
	const [assDate, setAssDate] = useState('Не выбрано');
	const [emptyData, setEmptyData] = useState(false);
	const [lessonValue, setLessonValue] = useState([]);

	const handleChangeSelect = (event) => {
		document.querySelector(".picked-lesson").classList.remove("red-border");
		setVisibleSliderBlock({ dateBirth: true, direction: true });
		setAssDate(event.target.value);
		setTimeout(() => {
			versionWheel.forEach((item, index) => {
				if (lessonValue[index] === event.target.value) {
					setDate(item.data.birth_date);
					setDataLastWheel(item.data);
				}
			})
		}, 100)
	};
	const handleClick = () => {
		dropValues();
		document.querySelector(".picked-lesson").classList.add("red-border");
		setVisibleSliderBlock(prevState => ({ ...prevState, direction: false }));
	}

	useEffect(() => {
		if (versionWheel.length === 0) {
			setEmptyData(true);
		}
		const tmpArr = [];
		versionWheel.forEach(item => {
			const value = item.data.subject.name + " (" + item.data.assessment_date + ")";
			tmpArr.push(value);
		})
		setLessonValue(tmpArr);
	}, [versionWheel])

	return (
		<Select
			labelId="demo-simple-select-filled-label"
			id="demo-simple-select-filled"
			value={assDate}
			onChange={handleChangeSelect}
			disableUnderline={true}
			sx={{ borderRadius: "12px", backgroundColor: "#F5F0E7" }}
		>
			{emptyData
				? <MenuItem value="">
					Нет данных
				</MenuItem>
				: <MenuItem onClick={handleClick}
					value="Не выбрано">Не выбрано
				</MenuItem>
			}

			{versionWheel.map((item, index) => (
				<MenuItem key={index} value={lessonValue[index]}>{lessonValue[index]}</MenuItem>
			))}
		</Select>
		// return versionWheel.map((item, index) => (
		//     <MenuItem key={index} value={item.data.assessment_date}>{item.data.assessment_date}</MenuItem>
		// ))
	)
}

function DisplaySelectDateAge(props) {
	const {
		birthDate,
		setVisibleSliderBlock,
		setCriterionRequestParam,
		criterionRequestParam,
		setListLessonItems,
		setSudentParametersValues,
		setCriterionError,
	} = props;

	const [assDate, setAssDate] = useState('null');

	useEffect(() => {
		setAssDate(criterionRequestParam.dateBirthValue || 'null');
	}, [criterionRequestParam]);

	const handleChangeSelect = (event) => {
		setAssDate(event.target.value);
		setVisibleSliderBlock(prevState => ({ ...prevState, dateBirth: true }));
	};

	const handleDrop = () => {
		setVisibleSliderBlock(prevState => ({ ...prevState, dateBirth: false }));
		setCriterionRequestParam((prevState) => ({
			...prevState,
			dateBirthValue: '',
			dateBirthName: '',
		}));
	}

	const handleClick = (value, name) => {
		setCriterionRequestParam(prevState => ({ ...prevState, dateBirthValue: value, dateBirthName: name }));

		const direction = criterionRequestParam.direction;

		if (typeof setCriterionError === 'function') {
			setCriterionError('');
		}

		if (direction && value && value !== 'null') {
			handleRequest(value, direction)
				.then((data) => {
					setListLessonItems(data);

					const skillKeys = Object.keys(data);
					const initialSkillItem = Object.fromEntries(skillKeys.map((key) => [key, 0]));

					setSudentParametersValues(initialSkillItem);
				})
				.catch((err) => {
					const message = err?.apiMessage || err?.message || 'Не удалось загрузить критерии';
					if (typeof setCriterionError === 'function') {
						setCriterionError(message);
					}
					setListLessonItems([]);
					setSudentParametersValues([]);
					setVisibleSliderBlock((prev) => ({ ...prev, dateBirth: false }));
				});
		}
	}

	return (
		<Select
			id="date-birth"
			value={assDate}
			name='birth_date'
			onChange={handleChangeSelect}
			disableUnderline={true}
			inputProps={{
				'data-name': 'Возраст ребенка',
			}}
			sx={{ borderRadius: "12px", backgroundColor: "#F5F0E7" }}
		>

			<MenuItem
				onClick={handleDrop}
				value="null">Не выбрано
			</MenuItem>


			{birthDate.map((item, index) => (
				<MenuItem
					key={index}
					value={item.name}
					onClick={() => handleClick(item.name, item.title)}
				>
					{item.title}
				</MenuItem>
			))}
		</Select>
	)

}

function getLastWheele(setWheel, childId) {
	apiFetch(`/getLastWheele?child_id=${childId}`)
		.then((response) => readApiJson(response))
		.then(({ ok, body }) => {
			if (!ok) {
				setWheel((prevState) => ({ ...prevState, versionWheel: [] }));
				return;
			}
			const list = Array.isArray(body) ? body : [];
			setWheel((prevState) => ({ ...prevState, versionWheel: list }));
		})
		.catch(() => {
			setWheel((prevState) => ({ ...prevState, versionWheel: [] }));
		});
}

const example = [
	{
		"name": "2y",
		"title": "2 года"
	},
	{
		"name": "3y",
		"title": "3 года"
	},
	{
		"name": "4y",
		"title": "4 года"
	},
	{
		"name": "5y",
		"title": "5 лет"
	},
	{
		"name": "6y",
		"title": "6 лет"
	},
	{
		"name": "uniqum",
		"title": "Уникум"
	},
	{
		"name": "1_class",
		"title": "1 класс"
	},
	{
		"name": "2_class",
		"title": "2 класс"
	},
	{
		"name": "3_class",
		"title": "3 класс"
	},
	{
		"name": "4_class",
		"title": "4 класс"
	},
	{
		"name": "5_class",
		"title": "5 класс"
	}
];

const example2 = {
	'2y': [
		{
			"Английский язык": [
				{
					"Творчество": [
						"1",
						"2",
						"3",
					]
				},
				{
					"Рисование": [
						"1",
						"2",
						"3",
					]
				}
			]
		},
		{
			"Общее": [
				{
					"Творчестов": [
						"1",
						"2",
						"3",
					]
				},
				{
					"Рисование": [
						"1",
						"2",
						"3",
					]
				}
			]
		},
		{
			"Логопед": [
				{
					"Творчестов": [
						"1",
						"2",
						"3",
					]
				},
				{
					"Рисование": [
						"1",
						"2",
						"3",
					]
				}
			]
		}
	],

	'3y': [
		{
			"Английский язык": [
				{
					"Творчество": [
						"1",
						"2",
						"3",
					]
				},
				{
					"Рисование": [
						"1",
						"2",
						"3",
					]
				}
			]
		},
		{
			"Общее": [
				{
					"Творчестов": [
						"1",
						"2",
						"3",
					]
				},
				{
					"Рисование": [
						"1",
						"2",
						"3",
					]
				}
			]
		}
	]
}
